// noinspection JSUnusedGlobalSymbols

import * as Apollo from '@apollo/client';

import { gql } from '@apollo/client';
import type * as Types from '../../__generated__/types';

const defaultOptions = {} as const;
export type ListJobsQueryVariables = Types.Exact<{
  pageNumber: Types.InputMaybe<Types.Scalars['Int']['input']>;
  pageSize: Types.InputMaybe<Types.Scalars['Int']['input']>;
  enabled: Types.InputMaybe<Types.Scalars['Boolean']['input']>;
  keyword: Types.InputMaybe<Types.Scalars['String']['input']>;
  hasEmployees?: Types.InputMaybe<Types.Scalars['Boolean']['input']>;
  onlyIds?: Types.InputMaybe<Array<Types.Scalars['ID']['input']> | Types.Scalars['ID']['input']>;
}>;

export type ListJobsQuery = { __typename?: 'Query' } & {
  listJobs: { __typename?: 'ListJobs' } & Pick<Types.ListJobs, 'totalCount'> & {
      items: Array<
        { __typename?: 'Job' } & Pick<Types.Job, 'id' | 'name' | 'enabled' | 'createdAt' | 'updatedAt'> & {
            defaultEpmMasterFunctionality: Types.Maybe<
              { __typename?: 'EpmMasterFunctionality' } & Pick<Types.EpmMasterFunctionality, 'id' | 'name'>
            >;
            definitions: Array<
              { __typename?: 'DefinitionItem' } & Pick<Types.DefinitionItem, 'languageCode' | 'displayName' | 'content'>
            >;
          }
      >;
    };
};

export const ListJobsDocument = /*#__PURE__*/ gql`
    query listJobs($pageNumber: Int, $pageSize: Int, $enabled: Boolean, $keyword: String, $hasEmployees: Boolean = null, $onlyIds: [ID!] = null) {
  listJobs(
    filter: {pageNumber: $pageNumber, pageSize: $pageSize, enabled: $enabled, keyword: $keyword, hasEmployees: $hasEmployees, onlyIds: $onlyIds}
  ) {
    items {
      id
      name
      enabled
      createdAt
      updatedAt
      defaultEpmMasterFunctionality {
        id
        name
      }
      definitions {
        languageCode
        displayName
        content
      }
    }
    totalCount
  }
}
    `;

/**
 * __useListJobsQuery__
 *
 * To run a query within a React component, call `useListJobsQuery` and pass it any options that fit your needs.
 * When your component renders, `useListJobsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useListJobsQuery({
 *   variables: {
 *      pageNumber: // value for 'pageNumber'
 *      pageSize: // value for 'pageSize'
 *      enabled: // value for 'enabled'
 *      keyword: // value for 'keyword'
 *      hasEmployees: // value for 'hasEmployees'
 *      onlyIds: // value for 'onlyIds'
 *   },
 * });
 */
export function useListJobsQuery(baseOptions?: Apollo.QueryHookOptions<ListJobsQuery, ListJobsQueryVariables>) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<ListJobsQuery, ListJobsQueryVariables>(ListJobsDocument, options);
}
export function useListJobsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ListJobsQuery, ListJobsQueryVariables>) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<ListJobsQuery, ListJobsQueryVariables>(ListJobsDocument, options);
}
// @ts-expect-error
export function useListJobsSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<ListJobsQuery, ListJobsQueryVariables>,
): Apollo.UseSuspenseQueryResult<ListJobsQuery, ListJobsQueryVariables>;
export function useListJobsSuspenseQuery(
  baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<ListJobsQuery, ListJobsQueryVariables>,
): Apollo.UseSuspenseQueryResult<ListJobsQuery | undefined, ListJobsQueryVariables>;
export function useListJobsSuspenseQuery(
  baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<ListJobsQuery, ListJobsQueryVariables>,
) {
  const options = baseOptions === Apollo.skipToken ? baseOptions : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<ListJobsQuery, ListJobsQueryVariables>(ListJobsDocument, options);
}
export type ListJobsQueryHookResult = ReturnType<typeof useListJobsQuery>;
export type ListJobsLazyQueryHookResult = ReturnType<typeof useListJobsLazyQuery>;
export type ListJobsSuspenseQueryHookResult = ReturnType<typeof useListJobsSuspenseQuery>;
